<div class="modal fade" id="kt_modal_edit_currency_rate" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Edit Currency Rate</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
        <form [formGroup]="currencyRateForm" (ngSubmit)="onSubmit()">
          <!-- Date Display (Read-only) -->
          <div class="mb-7" *ngIf="selectedCurrencyRate">
            <label class="fs-6 fw-semibold mb-2">Date</label>
            <input
              type="text"
              class="form-control form-control-solid"
              [value]="selectedCurrencyRate.date"
              readonly>
          </div>

          <!-- USD Input -->
          <div class="mb-7">
            <label class="required fs-6 fw-semibold mb-2">USD Rate</label>
            <input
              type="number"
              step="0.01"
              class="form-control form-control-solid"
              formControlName="usd"
              placeholder="Enter USD rate"
              [class.is-invalid]="currencyRateForm.get('usd')?.invalid && currencyRateForm.get('usd')?.touched">
            <div class="invalid-feedback" *ngIf="currencyRateForm.get('usd')?.invalid && currencyRateForm.get('usd')?.touched">
              <div *ngIf="currencyRateForm.get('usd')?.errors?.['required']">USD rate is required</div>
              <div *ngIf="currencyRateForm.get('usd')?.errors?.['min']">USD rate must be greater than or equal to 0</div>
            </div>
          </div>

          <!-- EUR Input -->
          <div class="mb-7">
            <label class="required fs-6 fw-semibold mb-2">EUR Rate</label>
            <input
              type="number"
              step="0.01"
              class="form-control form-control-solid"
              formControlName="eur"
              placeholder="Enter EUR rate"
              [class.is-invalid]="currencyRateForm.get('eur')?.invalid && currencyRateForm.get('eur')?.touched">
            <div class="invalid-feedback" *ngIf="currencyRateForm.get('eur')?.invalid && currencyRateForm.get('eur')?.touched">
              <div *ngIf="currencyRateForm.get('eur')?.errors?.['required']">EUR rate is required</div>
              <div *ngIf="currencyRateForm.get('eur')?.errors?.['min']">EUR rate must be greater than or equal to 0</div>
            </div>
          </div>

          <!-- GBP Input -->
          <div class="mb-7">
            <label class="required fs-6 fw-semibold mb-2">GBP Rate</label>
            <input
              type="number"
              step="0.01"
              class="form-control form-control-solid"
              formControlName="gbp"
              placeholder="Enter GBP rate"
              [class.is-invalid]="currencyRateForm.get('gbp')?.invalid && currencyRateForm.get('gbp')?.touched">
            <div class="invalid-feedback" *ngIf="currencyRateForm.get('gbp')?.invalid && currencyRateForm.get('gbp')?.touched">
              <div *ngIf="currencyRateForm.get('gbp')?.errors?.['required']">GBP rate is required</div>
              <div *ngIf="currencyRateForm.get('gbp')?.errors?.['min']">GBP rate must be greater than or equal to 0</div>
            </div>
          </div>

          <!-- Form Actions -->
          <div class="text-center pt-5">
            <button
              type="button"
              class="btn btn-light me-3"
              (click)="closeModal()"
              [disabled]="isLoading">
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="currencyRateForm.invalid || isLoading">
              <span *ngIf="!isLoading">Update Currency Rate</span>
              <span *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm align-middle me-2"></span>
                Updating...
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
